export default __webpack_public_path__ + "static/media/one.07de0d1b.jpg";